import React from 'react';
import {
    EuiListGroupItem,
    EuiListGroup,
  } from '@elastic/eui';
  
  export const ListadoUsuariosDelegado = (props) => {
  
    const {onSelect,data,selected,currentUser,type } = props;
    
    const onSelectedItem = (value) =>{
        onSelect && onSelect(value);
    }

    const getItemsUsers = ()=>{
      if(data && data.length>0){
        const newData = [...[currentUser],...data];
        return newData.map((d)=> 
        <EuiListGroupItem key={data.login} size='s' onClick={() => onSelectedItem(d)} label={`${d.nombre} (${d.login})`} color="text" className={selected.dni === d.dni ? 'activeItem' : 'item'}/>)
      }
    }

    const getItemsDelegados = ()=>{
      if(data && data.length>0){
        return data.map((d)=> 
        <EuiListGroupItem key={data.login} size='s' label={`${d.nombre} (${d.login})`} color="text" className={'item'}/>)
      }
    }
  
  return (
      <EuiListGroup>
        {type==='DEL' ? getItemsDelegados() : getItemsUsers()}
      </EuiListGroup>
  );
  
  }
  